module.exports = __webpack_public_path__ + "img/avatar4.08102ea0.png";